
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo/encrypt-wallet",
      function () {
        return require("private-next-pages/en/docs/komodo/encrypt-wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo/encrypt-wallet"])
      });
    }
  